import { createSlice } from '@reduxjs/toolkit';

const LoaderSlice = createSlice({
  name: 'loader',
  initialState: {
    OnClickloading: false,
    loading: false,
  },
  reducers: {
    openLoader: (state, param) => {
      const { payload } = param;
      state.loading = payload;
    },
    closeLoader: (state, param) => {
      const { payload } = param;
      state.loading = payload;
      state.OnClickloading = payload;
    },
    onClickLoader: (state, param) => {
      const { payload } = param;
      state.OnClickloading = payload;
    },
  },
});
const { actions, reducer } = LoaderSlice;

export const { openLoader, closeLoader, onClickLoader } = actions;
export default reducer;
